import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';

export function useStationGroups(stationIdOrSlug: string) {
  return useQuery({
    queryKey: ['station-groups', stationIdOrSlug],
    queryFn: () => apiClient.stations.fetchStationGroupsForStation(stationIdOrSlug),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
